<template>
    <v-app style="background-color: #c1c1c1">
        <top
            v-if="
                $route.path !== '/login' &&
                $route.path !== '/pedir-cita' &&
                $route.path !== '/forgot' &&
                $route.path !== '/reset-password'
            "
            v-on:toggleDrawer="toggleDrawer"
        ></top>
        <lateral
            v-if="
                $route.path !== '/login' &&
                $route.path !== '/pedir-cita' &&
                $route.path !== '/forgot' &&
                $route.path !== '/reset-password'
            "
            :drawer="drawer"
            v-on:emitInnputDrawer="getInnputDrawer"
        ></lateral>

        <v-main color="purple darken-3">
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
import Top from "../navs/Top.vue";
import Lateral from "../navs/Lateral.vue";
export default {
    components: {
        Top,
        Lateral,
    },
    created() {
        // alert("esto es un prueba temporal");
        this.$store.dispatch("getCountPost");
    },
    watch: {
        drawer: {
            immediate: true,
            handler: function (n) {},
        },
    },
    data() {
        return {
            drawer: true,
        };
    },
    methods: {
        isActive() {
            return false; //this.$route.path != '/login'
        },
        toggleDrawer() {
            this.drawer = !this.drawer;
        },
        getInnputDrawer(e) {
            this.drawer = e;
        },
    },
};
</script>
<style>
.flex {
    display: flex;
}
.absolute {
    position: absolute;
}
.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.w-6 {
    width: 6rem;
}
.h-6 {
    height: 6rem;
}
.h-3 {
    height: 3rem;
}
.w-4 {
    width: 4rem;
}
.h-2 {
    height: 2rem;
}
.row_red {
    background-color: rgb(250, 207, 207);
}
.pointer {
    cursor: pointer;
}
</style>
<style media="screen">
.v-application {
    font-family: "Roboto", sans-serif !important;
}
.title {
    font-family: "Roboto", sans-serif !important;
}

.my-container {
    padding: 1rem;
}

.v-content__wrap {
    background-color: #efeeee;
}

a {
    text-decoration: none;
}

/*.v-toolbar__title {
        font-weight: 300;
        color: #555;
        font-size: 18px;
        margin-bottom: 6px;
    }*/
</style>
